module.exports = __webpack_public_path__ + "static/img/temp-mobile-contents01@t.490b354.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-mobile-contents01@t.jpg
// module id = ESyo
// module chunks = 0